export const paidUserControlConstants = {
	Create: {
		REQUEST : 'CREATE_PAID_USER_CONTROL_REQUEST',
		SUCCESS : 'CREATE_PAID_USER_CONTROL_SUCCESS',
		FAILURE : 'CREATE_PAID_USER_CONTROL_FAILURE'
	},
	Update: {
		REQUEST : 'UPDATE_PAID_USER_CONTROL_REQUEST',
		SUCCESS : 'UPDATE_PAID_USER_CONTROL_SUCCESS',
		FAILURE : 'UPDATE_PAID_USER_CONTROL_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_PAID_USER_CONTROL_REQUEST',
		SUCCESS : 'DELETE_PAID_USER_CONTROL_SUCCESS',
		FAILURE : 'DELETE_PAID_USER_CONTROL_FAILURE'
	},
	GetPaged: {
		REQUEST : 'GET_PAGED_PAID_USER_CONTROLS_REQUEST',
		SUCCESS : 'GET_PAGED_PAID_USER_CONTROLS_SUCCESS',
		FAILURE : 'GET_PAGED_PAID_USER_CONTROLS_FAILURE'
	},
	Find: {
		REQUEST : 'FIND_PAID_USER_REQUEST',
		SUCCESS : 'FIND_PAID_USER_SUCCESS',
		FAILURE : 'FIND_PAID_USER_FAILURE'
	},
	Clear: "PAID_USER_CONTROL_CLEAR"
}